import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { MenuPermisos, OptionPermisos } from 'app/modules/admin/administrar/models/permisos.model';
import { RolesPermisosService } from 'app/modules/admin/administrar/roles-y-permisos.service';
import { Subscription, take } from 'rxjs';

@Directive({ selector: '[hasPermissions]' })

export class HasPermissionsDirective {
    private permiso: string;
    private modules: string[] = [];
    private subscription: Subscription;

    constructor(
        private _rolesPermisosService: RolesPermisosService,
        private _templateRef: TemplateRef<any>,
        private _viewContainer: ViewContainerRef
    ) {}

    @Input('hasPermissions') set hasPermissions(codigo: string) {
        this.permiso = codigo;
    }

    @Input() set hasPermissionsModulos(modules: string[]) {
        this.modules = modules || []; // asegura que no sea undefined
    }

    ngOnInit() {
        // Suscripción a los permisos
        this.subscription = this._rolesPermisosService.permisosUsuario$
            .subscribe(userPermissions => {
            this.updateView(userPermissions);
            });

    }

    private updateView(userPermissions: MenuPermisos[]) {
        if (!this.modules?.length) {;
            this._viewContainer.clear();
            return;
    }

    const hasPermission = this.modules.some(module => {
        const menu = userPermissions.find(m => m.nombreMenu === module);

        if (!menu || !menu.options?.length) {
        return false;
        }

        const permissionFound = menu.options.some(option => {
        const match = option.codigo?.trim() === this.permiso?.trim() && option.habilitado === true;
        return match;
        });

        return permissionFound;
    });


    if (hasPermission) {
            this._viewContainer.createEmbeddedView(this._templateRef);
        } else {
            this._viewContainer.clear();
        }
    }


    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }
}
